import { render, staticRenderFns } from "./DesignForm.vue?vue&type=template&id=b08b51a8&"
import script from "./DesignForm.vue?vue&type=script&lang=js&"
export * from "./DesignForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports